import { graphql } from 'gatsby';
import React from 'react';
import BilateralBlock from '../../components/Bilateral/BilateralBlock/bilateralBlock';
import BilateralContainerLayout from '../../components/Bilateral/BilateralContainerLayout/bilateralContainerLayout';
import BilateralImage from '../../components/Bilateral/BilateralImage/bilateralImage';
import SEO from '../../components/seo';
import TextComponent from '../../components/TextComponent/textComponent';
import VideoLibraries from '../../components/VideosLibraries/videoLibraries';
import LayoutContainer from '../../containers/layout';
import meetLuckyData from '../../normalization/meetLucky';
import meetMulliganData from '../../normalization/meetMulligan';
import './index.scss';

export const query = graphql`
  query DogDetailsPageQuery {
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;
const DogDetialsPage = (props) => {
  const { data, errors } = props;
  const { site } = data || {};

  const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : '';
  const { bilateralContainer, videoLibraryContainer } =
    urlParams !== '' && JSON.parse(urlParams?.get('name')) === 'mulligan' ? meetMulliganData() : meetLuckyData();
  return (
    <LayoutContainer>
      <SEO title={`${site.title} | ${urlParams !== '' ? JSON.parse(urlParams.get('name').toUpperCase()) : 'Turfmutt'}`} />
      <BilateralContainerLayout layoutStyle={bilateralContainer.layoutStyle}>
        {bilateralContainer.bilateralList.map((bilateral) => (
          <BilateralBlock key={Math.random().toString(36).substring(7)} layoutStyle={bilateral.className}>
            <TextComponent
              heading={`${bilateral.textComponent.headline}`}
              description={bilateral.textComponent.description}
              linksBtn={bilateral.textComponent.links.data}
              layoutStyle={bilateral.textComponent.className}
            />
            <BilateralImage src={bilateral.bilateralImage.webUrl} />
          </BilateralBlock>
        ))}
      </BilateralContainerLayout>
      <VideoLibraries
        layoutStyle={videoLibraryContainer.className}
        title={videoLibraryContainer.title}
        videosList={videoLibraryContainer.libraryList}
      />
    </LayoutContainer>
  );
};

export default DogDetialsPage;
